/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type TypeAddCart = 'new' | 'update';

@Injectable({
  providedIn: 'root'
})
export class CartPurchaseService {
  data$: BehaviorSubject<any[]>;
  data: any;

  constructor() {
    this.data = {};
    this.data$ = new BehaviorSubject<any[]>(Object.values(this.data));
  }

  getData$() {
    return this.data$.asObservable();
  }
  setData$() {
    this.data$.next(this.getDataAsArr());
  }
  getDataAsArr() {
    return Object.values(this.data);
  }
  addItem(item) {
    const id = item.id;
    this.data[id] = item;
    this.setData$();
  }
  removeItem(item) {
    const id = item.id;
    delete this.data[id];
    this.setData$();
  }
  isCartEmpty() {
    return Object.keys(this.data).length === 0;
  }
  getAmountPurchase(): number {
    const amount = this.getDataAsArr().reduce((acc: any, current: any) => {
      return acc + current.quantityCart * current.unitPrice;
    }, 0);
    return amount as number;
  }

  emptyData() {
    this.data = {};
    this.data$.next(Object.values(this.data));
  }
}
